import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ButtonBase, TableCell, TableRow, Typography } from '@mui/material';
import OverflowTooltip from './OverflowTooltip';
import { groupButtonSx, groupHeaderSx, groupLabelSx } from './styles';
import type { ListTableGroup, ListTableRow } from './types';

interface ListTableGroupRowProps<Row extends ListTableRow> {
  group: ListTableGroup<Row>;
  isExpanded: boolean;
  columnCount: number;
  groupRowHeight: number;
  onToggle: (group: ListTableGroup<Row>) => void;
}

const ListTableGroupRow = <Row extends ListTableRow>({
  group,
  isExpanded,
  columnCount,
  groupRowHeight,
  onToggle,
}: ListTableGroupRowProps<Row>) => (
  <TableRow sx={{ height: groupRowHeight }}>
    <TableCell colSpan={columnCount} sx={groupHeaderSx}>
      <ButtonBase aria-expanded={isExpanded} onClick={() => onToggle(group)} sx={groupButtonSx}>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: 20,
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 150ms ease-in-out',
          }}
        />
        <OverflowTooltip>
          <Typography component="span" color="brand" fontSize={14} fontWeight={600} noWrap sx={groupLabelSx}>
            {group.label}
          </Typography>
        </OverflowTooltip>
        {group.count !== undefined && ` (${group.count})`}
      </ButtonBase>
    </TableCell>
  </TableRow>
);

export default ListTableGroupRow;
